export type SwayStyle = 'overhead' | 'ritual' | 'hip-roll' | 'serpent' | 'siren' | 'pulse' | 'goth-club' | 'zombie' | 'twerk'
export type CharacterDance = { name: string; style: SwayStyle; duration: number; energy: number }

export const SHARED_PRESETS = [
  { name: 'Indoor Swing', clip: 'Indoor_Swing', action: 75 },
  { name: 'Shake It Off', clip: 'Shake_It_Off_Dance', action: 82 },
  { name: 'Gangnam Groove', clip: 'Gangnam_Groove', action: 74 },
  { name: 'Fast Lightning', clip: 'Fast_Lightning', action: 73 },
  { name: 'Party Shuffle', clip: 'FunnyDancing_02', action: 23 },
] as const
export const GOTHIC_FLOW: CharacterDance = { name: 'Gothic flow', style: 'goth-club', duration: 6, energy: 1.3 }
export const NEW_SHARED_DANCES: readonly CharacterDance[] = [
  { name: 'Thriller groove', style: 'zombie', duration: 8, energy: 1.05 },
  { name: 'Twerk', style: 'twerk', duration: 6, energy: 1.15 },
]
export const SHARED_DANCE_NAMES = [...SHARED_PRESETS.map(dance => dance.name), GOTHIC_FLOW.name]
export const SIGNATURE_START = SHARED_DANCE_NAMES.length

export const CHARACTER_DANCES = {
  velvet: [
    { name: 'Velvet temptation', style: 'siren', duration: 9, energy: 1.05 },
    { name: 'Ruby hip circles', style: 'hip-roll', duration: 8, energy: 1.15 },
    { name: 'Vampire flourish', style: 'serpent', duration: 9, energy: 1 },
  ],
  violet: [
    { name: 'Fallen angel sway', style: 'overhead', duration: 9, energy: 0.95 },
    { name: 'Halo invocation', style: 'ritual', duration: 10, energy: 0.9 },
    { name: 'Violet tide', style: 'siren', duration: 9, energy: 0.95 },
  ],
  nyx: [
    { name: 'Moon invocation', style: 'ritual', duration: 10, energy: 0.85 },
    { name: 'Midnight sway', style: 'overhead', duration: 8, energy: 1 },
    { name: 'Lunar hip circles', style: 'hip-roll', duration: 9, energy: 0.9 },
  ],
  ember: [
    { name: 'Infernal hip roll', style: 'hip-roll', duration: 7, energy: 1.15 },
    { name: 'Flame reach', style: 'overhead', duration: 8, energy: 1.1 },
    { name: 'Ember pulse', style: 'pulse', duration: 7, energy: 1 },
  ],
  luna: [
    { name: 'Celestial invocation', style: 'ritual', duration: 10, energy: 0.8 },
    { name: 'Starlight sway', style: 'overhead', duration: 9, energy: 0.85 },
    { name: 'Golden tide', style: 'siren', duration: 10, energy: 0.85 },
  ],
  raven: [
    { name: 'Vampire anthem', style: 'overhead', duration: 8, energy: 1 },
    { name: 'Velvet temptation', style: 'siren', duration: 9, energy: 1 },
    { name: 'Bloodmoon hips', style: 'hip-roll', duration: 8, energy: 1.05 },
  ],
  jade: [
    { name: 'Serpent weave', style: 'serpent', duration: 8, energy: 1 },
    { name: 'Emerald coils', style: 'hip-roll', duration: 9, energy: 1.15 },
    { name: 'Enchantress reach', style: 'overhead', duration: 9, energy: 0.9 },
  ],
  nova: [
    { name: 'Neon pulse', style: 'pulse', duration: 6, energy: 1.1 },
    { name: 'Circuit sway', style: 'overhead', duration: 7, energy: 1 },
    { name: 'Electric weave', style: 'serpent', duration: 7, energy: 1 },
  ],
  marina: [
    { name: 'Siren song', style: 'siren', duration: 9, energy: 1 },
    { name: 'Rolling tide', style: 'hip-roll', duration: 8, energy: 1.1 },
    { name: 'Moonlit salute', style: 'overhead', duration: 8, energy: 1 },
  ],
  wobble: [
    { name: 'Royal wobble', style: 'hip-roll', duration: 7, energy: 1.25 },
    { name: 'Knight fever', style: 'pulse', duration: 6, energy: 1.2 },
    { name: 'Courtly flourish', style: 'ritual', duration: 8, energy: 1.1 },
  ],
  goblin: [
    { name: 'Gold-chain groove', style: 'pulse', duration: 6, energy: 1.3 },
    { name: 'Pocket chaos', style: 'serpent', duration: 7, energy: 1.25 },
    { name: 'Goblin swagger', style: 'hip-roll', duration: 7, energy: 1.2 },
  ],
  fizz: [
    { name: 'Spell shuffle', style: 'ritual', duration: 8, energy: 1.05 },
    { name: 'Potion panic', style: 'pulse', duration: 6, energy: 1.2 },
    { name: 'Wizard weave', style: 'serpent', duration: 8, energy: 1.1 },
  ],
  jinx: [
    { name: 'Jester tease', style: 'siren', duration: 7, energy: 1.2 },
    { name: 'Bell flourish', style: 'overhead', duration: 8, energy: 1.2 },
    { name: 'Diamond hips', style: 'hip-roll', duration: 7, energy: 1.3 },
  ],
  bolt: [
    { name: 'Circuit pulse', style: 'pulse', duration: 6, energy: 1.15 },
    { name: 'Signal weave', style: 'serpent', duration: 7, energy: 1.1 },
    { name: 'Servo shuffle', style: 'hip-roll', duration: 6, energy: 1.05 },
  ],
  bones: [
    { name: 'Bone boogie', style: 'pulse', duration: 7, energy: 1.2 },
    { name: 'Haunted flourish', style: 'ritual', duration: 9, energy: 1 },
    { name: 'Graveyard sway', style: 'serpent', duration: 8, energy: 1.1 },
  ],
  sprout: [
    { name: 'Flower-power hips', style: 'hip-roll', duration: 7, energy: 1.2 },
    { name: 'Petal twirl', style: 'overhead', duration: 8, energy: 1.15 },
    { name: 'Woodland weave', style: 'serpent', duration: 8, energy: 1.1 },
  ],
  groove: [
    { name: 'Disco experiment', style: 'pulse', duration: 6, energy: 1.25 },
    { name: 'Chemistry sway', style: 'siren', duration: 8, energy: 1.15 },
    { name: 'Eureka flourish', style: 'ritual', duration: 8, energy: 1.1 },
  ],
  zombie: [
    { name: 'Graveyard strut', style: 'zombie', duration: 8, energy: 1.1 },
    { name: 'Undead pulse', style: 'pulse', duration: 7, energy: 1.15 },
    { name: 'Midnight resurrection', style: 'ritual', duration: 9, energy: 1.05 },
  ],
} as const satisfies Record<string, readonly CharacterDance[]>
